import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

function StreamComplete() {
    const { t } = useTranslation();
    return (
        <div className="stream-complete-header">
            <Typography variant="h2" className="stream-complete-title">{t('header.stream_modal.stream_complete')}</Typography>
        </div>
    );
}

export default StreamComplete;